import React from 'react';
import Svg from 'components/Svg/Svg';
import { SvgProps } from 'components/Svg/types';

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 280 280" {...props}>
      <circle cx="150" cy="150" r="120" fill="white" />
      <g
        transform="translate(0.000000,280.000000) scale(0.100000,-0.100000)"
        fill="#1850e2"
        stroke="none"
      >
        <path
          d="M1255 2789 c-155 -15 -377 -82 -510 -155 -174 -94 -375 -269 -479
        -416 -367 -520 -346 -1220 50 -1698 261 -314 615 -494 1016 -516 325 -18 685
        96 928 295 325 265 509 616 535 1021 11 170 -29 439 -83 563 -10 23 -25 58
        -32 77 -22 56 -96 187 -147 259 -65 91 -242 266 -335 328 -202 137 -432 220
        -665 243 -111 11 -163 11 -278 -1z m275 -580 c71 -11 212 -59 269 -92 212
        -122 372 -351 410 -587 74 -452 -249 -883 -707 -942 -382 -50 -743 176 -877
        550 -130 362 32 780 380 981 53 31 190 79 257 90 75 12 192 13 268 0z"
        />
        <path
          d="M1157 1642 c-15 -16 -17 -48 -17 -244 0 -205 2 -226 18 -241 16 -15
        48 -17 244 -17 205 0 226 2 241 18 15 16 17 48 17 244 0 205 -2 226 -18 241
        -16 15 -48 17 -244 17 -205 0 -226 -2 -241 -18z"
        />
      </g>
    </Svg>
  );
};

export default Icon;
